import { useEffect } from "react";

/**
 * Use a custom title for the window
 */
const usePageTitle = (title?: string) => {
  useEffect(() => {
    window.document.title = (title ? `${title} | ` : "") + "Capture the Bug";
  }, [title]);
};

export default usePageTitle;
